// Added JavaScript proceeding theme.js (that doesn't require any liquid or any vars from the .js.liquid theme file)
// Runs on every theme page. Allows for easier editing/highlighting when can be pure JS
$(window).scroll(function() {
  var s = $(".mk-page");
  var pos = s.position();

  if (s.length) {
    var windowpos = $(window).scrollTop();
    if (windowpos >= pos.top & windowpos <=0) {
      s.removeClass("mk-page--scrolled");
    } else {
      s.addClass("mk-page--scrolled");
    }
  }

  $(".mk-page").removeClass("mk-page--bottom");
  if ($(window).scrollTop() + $(window).height() > ($(document).height() - 100) ) {
    // At bottom
    $(".mk-page").addClass("mk-page--bottom");
  }
});

$(function () {
  // Draggy
  $('.js-mk-draggy').each(function () {
    $(this).draggable();
  });

  // Back to top button
  $('body').on('click', '.js-scroll-to-top', function(e) {
    $('html, body').animate({
      scrollTop: $(".mk-body").offset().top
    }, 800);
    e.preventDefault();
  });

  // Runs on product page
  if ($('body').hasClass('template-product')) {
    // Load all vimeo video campaigns
    document.querySelectorAll('.vimeo-campaign').forEach(function (video) {
      let video_url = video.dataset.url;
      fetch('https://vimeo.com/api/oembed.json?url=' + video_url + '?allow=autoplay&autoplay=1&muted=1&controls=true&responsive=true&muted=true&loop=true&background=true')
      .then(function (prom) {
        return prom.json()
      })
      .then(function(res) {
        video.insertAdjacentHTML('afterbegin', res.html)
      })
      .catch(function (e) {
        console.log(e)
      });
    });
  }

  $('.mk-product-slider').on('init', function(event, slick){
    if (slick.slideCount <= 1) {
      $('.slick-dots').hide(); // Hides the dots
    }
  });

  //Slider
  $('.mk-product-slider').on('init', function(event, slick) {
    const $dots = $('.slick-dots');
    $dots.append('<div class="active-indicator"></div>');
    updateActiveIndicatorPosition(slick.currentSlide);
    $('.current').text(slick.currentSlide + 1);
    $('.total').text(slick.slideCount);
  });

  $('.mk-product-slider').slick({
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    draggable: true,
    dots: true,
    autoplay: false,
    adaptiveHeight: false,
    arrows: true,
    touchThreshold: 100,
    useCSS: false,
    useTransform: false,
    prevArrow: $('.prev'),
    nextArrow: $('.next')
  });

  // When the counter is clicked, go to the next slide
  $('.slick-counter').on('click', function() {
    $('.mk-product-slider').slick('slickNext');
  });

  // Update current slide number before the change
  $('.mk-product-slider').on('beforeChange', function(event, slick, currentSlide, nextSlide) {
    $('.current').text(nextSlide + 1);
  });

  // Update active indicator position
  $(".mk-product-slider").on('setPosition', function(event, slick) {
    updateActiveIndicatorPosition(slick.currentSlide);
  });

  $(".mk-product-slider").on('beforeChange', function(event, slick, currentSlide, nextSlide) {
    updateActiveIndicatorPosition(nextSlide);
    // Update settings based on the new active slide
  });

  // Function to update the active indicator position
  function updateActiveIndicatorPosition(slideIndex) {
    const $activeIndicator = $('.active-indicator');
    const $dots = $('.slick-dots li');
    const $targetDot = $dots.eq(slideIndex);
    const targetLeft = $targetDot.position().left;
    const targetWidth = $targetDot.outerWidth(true);

    $activeIndicator.css({
      width: targetWidth,
      left: targetLeft
    });
  }

  // Custom drag functionality for dots
  let isDragging = false;
  let startPos = 0;

  function handleCustomDragging(e) {
    if (!isDragging) return;

    let currentPos = e.pageX || e.originalEvent.touches[0].pageX;
    let delta = currentPos - startPos;

    if (delta > 50) {
      // Swiped right
      $(".mk-product-slider").slick('slickPrev');
      isDragging = false;
    } else if (delta < -50) {
      // Swiped left
      $(".mk-product-slider").slick('slickNext');
      isDragging = false;
    }
  }

  function startCustomDragging(e) {
    const $dots = $('.slick-dots');
    if ($dots.is(e.target) || $dots.has(e.target).length > 0) {
      isDragging = true;
      startPos = e.pageX || e.originalEvent.touches[0].pageX;
    }
  }

  function stopCustomDragging() {
    isDragging = false;
  }

  // Attach event handlers for custom dragging
  $('.slick-dots').on('mousedown touchstart', startCustomDragging);
  $(document).on('mousemove touchmove', handleCustomDragging);
  $(document).on('mouseup touchend', stopCustomDragging);

  // When a variant is selected from the dropdown, go to the first slide
  $('#product-variants select').on('change', function() {
    $('.mk-product-slider').slick('slickGoTo', 0); // reset to first slide
  });

  $('body').on('click', '.mk-checkout-duties-checkbox', function(e) {
    e.preventDefault();
    $(".mk-checkbox").addClass("mk-checkbox--checked");
    $(".mk-cart-button-container").removeClass("mk-cart-button-container--blocked");
    $(".mk-checkout-duties-checkbox-container").removeClass("mk-checkout-duties-checkbox-container--highlight");
  });

  $('body').on('click', '.mk-cart-button-container--blocked', function(e) {
    e.preventDefault();
    $(".mk-checkout-duties-checkbox-container").addClass("mk-checkout-duties-checkbox-container--highlight");
  });

  $('body').on('click', '#mobile-menu-toggle', function(e) {
    e.preventDefault();
    $(".mk-menu-icon-container").toggleClass("mk-menu-icon-container--open");
    $(".mk-mobile-menu").toggleClass("mk-mobile-menu--open");
    $(".mk-page").toggleClass("mk-page--mobile-menu-is-open");
  });

  $('body').on('mouseenter', '.mk-nav-shop-toggle', function(e) {
    e.preventDefault();
    $(".mk-secondary-nav").addClass("mk-secondary-nav--shop");
    $(".mk-secondary-nav").removeClass("mk-secondary-nav--visit");
    $(".mk-secondary-nav").removeClass("mk-secondary-nav--guide");
    $(".mk-secondary-nav").removeClass("mk-secondary-nav--about");
    $(".mk-secondary-nav").removeClass("mk-secondary-nav--journal");
  });
  $('body').on('mouseenter', '.mk-nav-visit-toggle', function(e) {
    e.preventDefault();
    $(".mk-secondary-nav").addClass("mk-secondary-nav--visit");
    $(".mk-secondary-nav").removeClass("mk-secondary-nav--about");
    $(".mk-secondary-nav").removeClass("mk-secondary-nav--guide");
    $(".mk-secondary-nav").removeClass("mk-secondary-nav--shop");
    $(".mk-secondary-nav").removeClass("mk-secondary-nav--journal");
  });
  $('body').on('mouseenter', '.mk-nav-guides-toggle', function(e) {
    e.preventDefault();
    $(".mk-secondary-nav").addClass("mk-secondary-nav--guide");
    $(".mk-secondary-nav").removeClass("mk-secondary-nav--shop");
    $(".mk-secondary-nav").removeClass("mk-secondary-nav--visit");
    $(".mk-secondary-nav").removeClass("mk-secondary-nav--about");
    $(".mk-secondary-nav").removeClass("mk-secondary-nav--journal");
  });
  $('body').on('mouseenter', '.mk-nav-about-toggle', function(e) {
    e.preventDefault();
    $(".mk-secondary-nav").addClass("mk-secondary-nav--about");
    $(".mk-secondary-nav").removeClass("mk-secondary-nav--guide");
    $(".mk-secondary-nav").removeClass("mk-secondary-nav--shop");
    $(".mk-secondary-nav").removeClass("mk-secondary-nav--visit");
    $(".mk-secondary-nav").removeClass("mk-secondary-nav--journal");
  });
  $('body').on('mouseenter', '.mk-nav-journal-toggle', function(e) {
    e.preventDefault();
    $(".mk-secondary-nav").addClass("mk-secondary-nav--journal");
    $(".mk-secondary-nav").removeClass("mk-secondary-nav--guide");
    $(".mk-secondary-nav").removeClass("mk-secondary-nav--shop");
    $(".mk-secondary-nav").removeClass("mk-secondary-nav--visit");
    $(".mk-secondary-nav").removeClass("mk-secondary-nav--about");
  });
  $('body').on('mouseleave', '.mk-secondary-nav', function(e) {
    e.preventDefault();
    $(this).removeClass("mk-secondary-nav--guide");
    $(this).removeClass("mk-secondary-nav--shop");
    $(this).removeClass("mk-secondary-nav--visit");
    $(this).removeClass("mk-secondary-nav--about");
    $(this).removeClass("mk-secondary-nav--journal");
  });

  // Mobile secondary nav
  $('body').on('click', '.mk-mobile-nav-shop-toggle', function(e) {
    e.preventDefault();
    $(".mk-mobile-secondary-nav-list-shop").toggleClass("mk-mobile-secondary-nav-list--open");
    $(this).toggleClass("mk-mobile-nav-toggle--open");

    $(".mk-mobile-nav-visit-toggle").removeClass("mk-mobile-nav-toggle--open");
    $(".mk-mobile-secondary-nav-list-visit").removeClass("mk-mobile-secondary-nav-list--open");
    $(".mk-mobile-nav-guides-toggle").removeClass("mk-mobile-nav-toggle--open");
    $(".mk-mobile-secondary-nav-list-guide").removeClass("mk-mobile-secondary-nav-list--open");
    $(".mk-mobile-nav-visit-toggle").removeClass("mk-mobile-nav-toggle--open");
    $(".mk-mobile-secondary-nav-list-visit").removeClass("mk-mobile-secondary-nav-list--open");
    $(".mk-mobile-nav-about-toggle").removeClass("mk-mobile-nav-toggle--open");
    $(".mk-mobile-secondary-nav-list-about").removeClass("mk-mobile-secondary-nav-list--open");
    $(".mk-mobile-nav-info-toggle").removeClass("mk-mobile-nav-toggle--open");
    $(".mk-mobile-secondary-nav-list-info").removeClass("mk-mobile-secondary-nav-list--open");
  });

  $('body').on('click', '.mk-mobile-nav-visit-toggle', function(e) {
    e.preventDefault();
    $(".mk-mobile-secondary-nav-list-visit").toggleClass("mk-mobile-secondary-nav-list--open");
    $(this).toggleClass("mk-mobile-nav-toggle--open");

    $(".mk-mobile-nav-about-toggle").removeClass("mk-mobile-nav-toggle--open");
    $(".mk-mobile-secondary-nav-list-about").removeClass("mk-mobile-secondary-nav-list--open");
    $(".mk-mobile-nav-guides-toggle").removeClass("mk-mobile-nav-toggle--open");
    $(".mk-mobile-secondary-nav-list-guide").removeClass("mk-mobile-secondary-nav-list--open");
    $(".mk-mobile-nav-assistance-toggle").removeClass("mk-mobile-nav-toggle--open");
    $(".mk-mobile-secondary-nav-list-assistance").removeClass("mk-mobile-secondary-nav-list--open");
    $(".mk-mobile-nav-shop-toggle").removeClass("mk-mobile-nav-toggle--open");
    $(".mk-mobile-secondary-nav-list-shop").removeClass("mk-mobile-secondary-nav-list--open");
    $(".mk-mobile-nav-info-toggle").removeClass("mk-mobile-nav-toggle--open");
    $(".mk-mobile-secondary-nav-list-info").removeClass("mk-mobile-secondary-nav-list--open");
  });

  $('body').on('click', '.mk-mobile-nav-guides-toggle', function(e) {
    e.preventDefault();
    $(".mk-mobile-secondary-nav-list-guide").toggleClass("mk-mobile-secondary-nav-list--open");
    $(this).toggleClass("mk-mobile-nav-toggle--open");

    $(".mk-mobile-nav-visit-toggle").removeClass("mk-mobile-nav-toggle--open");
    $(".mk-mobile-secondary-nav-list-visit").removeClass("mk-mobile-secondary-nav-list--open");
    $(".mk-mobile-nav-about-toggle").removeClass("mk-mobile-nav-toggle--open");
    $(".mk-mobile-secondary-nav-list-about").removeClass("mk-mobile-secondary-nav-list--open");
    $(".mk-mobile-nav-assistance-toggle").removeClass("mk-mobile-nav-toggle--open");
    $(".mk-mobile-secondary-nav-list-assistance").removeClass("mk-mobile-secondary-nav-list--open");
    $(".mk-mobile-nav-shop-toggle").removeClass("mk-mobile-nav-toggle--open");
    $(".mk-mobile-secondary-nav-list-shop").removeClass("mk-mobile-secondary-nav-list--open");
    $(".mk-mobile-nav-info-toggle").removeClass("mk-mobile-nav-toggle--open");
    $(".mk-mobile-secondary-nav-list-info").removeClass("mk-mobile-secondary-nav-list--open");
  });

  $('body').on('click', '.mk-mobile-nav-about-toggle', function(e) {
    e.preventDefault();
    $(".mk-mobile-secondary-nav-list-about").toggleClass("mk-mobile-secondary-nav-list--open");
    $(this).toggleClass("mk-mobile-nav-toggle--open");

    $(".mk-mobile-nav-visit-toggle").removeClass("mk-mobile-nav-toggle--open");
    $(".mk-mobile-secondary-nav-list-visit").removeClass("mk-mobile-secondary-nav-list--open");
    $(".mk-mobile-nav-guides-toggle").removeClass("mk-mobile-nav-toggle--open");
    $(".mk-mobile-secondary-nav-list-guide").removeClass("mk-mobile-secondary-nav-list--open");
    $(".mk-mobile-nav-assistance-toggle").removeClass("mk-mobile-nav-toggle--open");
    $(".mk-mobile-secondary-nav-list-assistance").removeClass("mk-mobile-secondary-nav-list--open");
    $(".mk-mobile-nav-shop-toggle").removeClass("mk-mobile-nav-toggle--open");
    $(".mk-mobile-secondary-nav-list-shop").removeClass("mk-mobile-secondary-nav-list--open");
    $(".mk-mobile-nav-info-toggle").removeClass("mk-mobile-nav-toggle--open");
    $(".mk-mobile-secondary-nav-list-info").removeClass("mk-mobile-secondary-nav-list--open");
  });

  $('body').on('click', '.mk-mobile-nav-assistance-toggle', function(e) {
    e.preventDefault();
    $(".mk-mobile-secondary-nav-list-assistance").toggleClass("mk-mobile-secondary-nav-list--open");
    $(this).toggleClass("mk-mobile-nav-toggle--open");

    $(".mk-mobile-nav-visit-toggle").removeClass("mk-mobile-nav-toggle--open");
    $(".mk-mobile-secondary-nav-list-visit").removeClass("mk-mobile-secondary-nav-list--open");
    $(".mk-mobile-nav-guides-toggle").removeClass("mk-mobile-nav-toggle--open");
    $(".mk-mobile-secondary-nav-list-guide").removeClass("mk-mobile-secondary-nav-list--open");
    $(".mk-mobile-nav-about-toggle").removeClass("mk-mobile-nav-toggle--open");
    $(".mk-mobile-secondary-nav-list-about").removeClass("mk-mobile-secondary-nav-list--open");
    $(".mk-mobile-nav-shop-toggle").removeClass("mk-mobile-nav-toggle--open");
    $(".mk-mobile-secondary-nav-list-shop").removeClass("mk-mobile-secondary-nav-list--open");
    $(".mk-mobile-nav-info-toggle").removeClass("mk-mobile-nav-toggle--open");
    $(".mk-mobile-secondary-nav-list-info").removeClass("mk-mobile-secondary-nav-list--open");
  });

  $('body').on('click', '.mk-mobile-nav-info-toggle', function(e) {
    e.preventDefault();
    $(".mk-mobile-secondary-nav-list-info").toggleClass("mk-mobile-secondary-nav-list--open");
    $(this).toggleClass("mk-mobile-nav-toggle--open");

    $(".mk-mobile-nav-visit-toggle").removeClass("mk-mobile-nav-toggle--open");
    $(".mk-mobile-secondary-nav-list-visit").removeClass("mk-mobile-secondary-nav-list--open");
    $(".mk-mobile-nav-guides-toggle").removeClass("mk-mobile-nav-toggle--open");
    $(".mk-mobile-secondary-nav-list-guide").removeClass("mk-mobile-secondary-nav-list--open");
    $(".mk-mobile-nav-about-toggle").removeClass("mk-mobile-nav-toggle--open");
    $(".mk-mobile-secondary-nav-list-about").removeClass("mk-mobile-secondary-nav-list--open");
    $(".mk-mobile-nav-shop-toggle").removeClass("mk-mobile-nav-toggle--open");
    $(".mk-mobile-secondary-nav-list-shop").removeClass("mk-mobile-secondary-nav-list--open");
    $(".mk-mobile-nav-assistancet-toggle").removeClass("mk-mobile-nav-toggle--open");
    $(".mk-mobile-secondary-nav-list-assistance").removeClass("mk-mobile-secondary-nav-list--open");
  });

  // Filter nav
  $('body').on('click', '.mk-child-toggle', function(e) {
    e.preventDefault();
    $(this).parents(".mk-filter-menu-item").toggleClass("mk-filter-menu-item--child-open");
  });

  $('body').on('click', '.mk-grandchild-toggle', function(e) {
    e.preventDefault();
    $(this).parents(".mk-filter-menu-item--grandchild").toggleClass("mk-filter-menu-item--grandchild-open");
  });

  //  Search toggle
  $('body').on('click', '.mk-search-toggle', function(e) {
    e.preventDefault();
    $(".mk-search-popup").toggleClass("mk-search-popup--open");
    $("#mk-searchinput").focus();
  });

  $(document).ready(function() {
    var $input = $("#mk-searchinput");
    $input.val('');
    $input.focus();
  });

  // Accordion toggle on product page
  $('body').on('click', '.mk-product-desc-toggle', function(e) {
    e.preventDefault();
    $(this).parents(".mk-product-desc-accordian").toggleClass("mk-product-desc-accordian--open");
  });

  $('body').on('click', '.mk-product-desc-expand-toggle', function(e) {
    e.preventDefault();
    $(".mk-product-desc-details--expand").toggleClass("mk-product-desc-details--expanded");
  });

  //  Sizing chart toggle
  $('body').on('click', '.js-sizing-chart', function(e) {
    e.preventDefault();
    $(".mk-size-chart-container").toggleClass("mk-size-chart-container--open");
    $(".mk-body").toggleClass("mk-body--size-chart-open");
  });

  $('body').on('click', '.mk-toggle-mto', function(e) {
    e.preventDefault();
    $(".mk-mto-popup").toggleClass("mk-mto-popup--open");
  });

  $('body').on('click', '.mk-filter-toggle', function(e) {
    e.preventDefault();
    $(".mk-mobile-filter-navigation-container").toggleClass("mk-mobile-filter-navigation-container--refine-open");
    $(".mk-page").toggleClass("mk-page--refine-open");
  });

  $('body').on('click', '.mk-filter-toggle-close', function(e) {
    e.preventDefault();
    $(".mk-mobile-filter-navigation-container").removeClass("mk-mobile-filter-navigation-container--refine-open");
    $(".mk-page").removeClass("mk-page--refine-open");
  });

  // Bind apply filter on radio button select
  $('input[type=checkbox]').on('change', function() {
    var selection = $(this);
    if (selection.hasClass('mk-filter-group-list-item-input')) {
      console.log('dz');
      selection.closest("form").submit();
    } else {
      console.log('dznt');
    }
  });
});
